import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { animationIsOkay } from "../../utils/utilFunctions";

// FIXME: reset timeline when change theme
const HeaderImage = () => {
  const lightRef = useRef<SVGPathElement>(null);
  const tl = gsap.timeline({ paused: true });
  useEffect(() => {
    tl.to(lightRef.current, {
      opacity: 0,
      duration: 0,
    })
      .to(
        lightRef.current,
        {
          opacity: 0.3,
          duration: 0.5,
        },
        "+=2"
      )
      .to(lightRef.current, {
        opacity: 0.1,
        duration: 1,
        repeat: -1,
        repeatDelay: 2,
        yoyoEase: "power2.inOut",
        yoyo: true,
      });
  }, []);

  useEffect(() => {
    if (animationIsOkay()) {
      tl.play();
    }
  }, []);

  return (
    <div className="header__image-wrapper">
      <svg viewBox="0 0 426.73 406.94" className="header-svg__me">
        <defs>
          <linearGradient
            id="header-svg__linear-gradient"
            x1="3.07"
            x2="368.15"
            y1="213.59"
            y2="213.59"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" />
            <stop offset=".09" stopOpacity=".95" />
            <stop offset=".24" stopOpacity=".83" />
            <stop offset=".45" stopOpacity=".64" />
            <stop offset=".7" stopOpacity=".36" />
            <stop offset=".99" stopOpacity=".02" />
            <stop offset="1" stopOpacity="0" />
          </linearGradient>
        </defs>
        <g id="git">
          <path
            d="M378 116.45v22.26a2.61 2.61 0 0 0 2.61 2.6h22.27a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.59-2.6h-22.26A2.62 2.62 0 0 0 378 116a3.57 3.57 0 0 0 0 .45ZM378 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.59 2.59 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.6-2.6H380.6a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M378 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.59 2.59 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.6-2.6H380.6a2.61 2.61 0 0 0-2.6 2.6ZM378 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.6-2.6H380.6a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M378 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.59 2.59 0 0 0-2.6-2.59H380.6a2.61 2.61 0 0 0-2.6 2.59Z"
            className="header-svg__git-dark"
          />
          <path
            d="M331.24 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.59 2.59 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6ZM331.24 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.59 2.59 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M331.24 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M331.24 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6ZM331.24 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.59 2.59 0 0 0-2.6-2.59h-22.26a2.61 2.61 0 0 0-2.6 2.59ZM284.48 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.59 2.59 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M284.48 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.59 2.59 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6ZM284.48 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-light"
          />
          <path
            d="M284.48 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.6-2.6h-22.26a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M284.48 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.27a2.59 2.59 0 0 0 2.59-2.6V154.4a2.59 2.59 0 0 0-2.6-2.59h-22.26a2.61 2.61 0 0 0-2.6 2.59Z"
            className="header-svg__primary"
          />
          <path
            d="M237.72 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.59-2.6h-22.27a2.61 2.61 0 0 0-2.6 2.6ZM237.72 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.59-2.6h-22.27a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-light"
          />
          <path
            d="M237.72 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.59-2.6h-22.27a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M237.72 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.59-2.6h-22.27a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M237.72 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.58 2.58 0 0 0-2.59-2.6h-22.27a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M191 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.63-2.6h-22.27A2.61 2.61 0 0 0 191 2.6ZM191 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.59-2.6h-22.31a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__git-light"
          />
          <path
            d="M191 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.59-2.6h-22.31a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M191 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.59-2.6h-22.31a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M191 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.58 2.58 0 0 0-2.59-2.6h-22.31a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__git-light"
          />
          <path
            d="M144.2 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.59-2.6H146.8a2.61 2.61 0 0 0-2.6 2.6ZM144.2 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.59-2.6H146.8a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M144.2 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.59-2.6H146.8a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M144.2 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.59-2.6H146.8a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-light"
          />
          <path
            d="M144.2 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.58 2.58 0 0 0-2.59-2.6H146.8a2.61 2.61 0 0 0-2.6 2.6ZM97.44 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V2.6a2.59 2.59 0 0 0-2.59-2.6H100a2.61 2.61 0 0 0-2.56 2.6ZM97.44 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V40.55a2.59 2.59 0 0 0-2.59-2.6H100a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M97.44 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.59-2.6H100a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M97.44 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.59-2.6H100a2.61 2.61 0 0 0-2.56 2.6ZM97.44 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.58 2.58 0 0 0-2.59-2.6H100a2.61 2.61 0 0 0-2.56 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M50.68 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V2.6A2.59 2.59 0 0 0 75.55 0H53.28a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M50.68 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.58 2.58 0 0 0 2.59-2.59V40.55A2.59 2.59 0 0 0 75.55 38H53.28a2.61 2.61 0 0 0-2.6 2.55ZM50.68 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V78.5a2.59 2.59 0 0 0-2.59-2.6H53.28a2.61 2.61 0 0 0-2.6 2.6ZM50.68 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6v-22.26a2.59 2.59 0 0 0-2.59-2.6H53.28a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M50.68 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6h22.28a2.58 2.58 0 0 0 2.58-2.6V154.4a2.58 2.58 0 0 0-2.59-2.6H53.28a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-light"
          />
          <path
            d="M3.92 2.6v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.6 2.6 0 0 0 2.6-2.59V2.6a2.6 2.6 0 0 0-2.6-2.6H6.52a2.61 2.61 0 0 0-2.6 2.6ZM3.92 40.55v22.27a2.61 2.61 0 0 0 2.6 2.59h22.27a2.6 2.6 0 0 0 2.6-2.59V40.55a2.6 2.6 0 0 0-2.6-2.6H6.52a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
          <path
            d="M3.92 78.5v22.26a2.61 2.61 0 0 0 2.6 2.6H28.8a2.6 2.6 0 0 0 2.59-2.6V78.5a2.6 2.6 0 0 0-2.6-2.6H6.52a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__primary"
          />
          <path
            d="M3.92 116.45v22.26a2.61 2.61 0 0 0 2.6 2.6H28.8a2.6 2.6 0 0 0 2.59-2.6v-22.26a2.6 2.6 0 0 0-2.6-2.6H6.52a2.61 2.61 0 0 0-2.6 2.6ZM3.92 154.4v22.26a2.61 2.61 0 0 0 2.6 2.6H28.8a2.6 2.6 0 0 0 2.59-2.6V154.4a2.59 2.59 0 0 0-2.6-2.6H6.52a2.61 2.61 0 0 0-2.6 2.6Z"
            className="header-svg__git-dark"
          />
        </g>
        <g id="Me">
          <path
            d="M74.19 287.75c7.37-25.41 9.52-50.34 0-69.29l1.73 24.66a206.3 206.3 0 0 1-1.73 44.63ZM66.77 250.63l.83 14.68a152.21 152.21 0 0 1-.83 26.57c3.54-15.13 4.58-29.97 0-41.25Z"
            className="header-svg__primary"
          />
          <g id="f9b32178-6d95-472d-b482-6662972666de">
            <path
              d="M38.1 323.92a11.49 11.49 0 1 0 11.49-11.49 11.49 11.49 0 0 0-11.49 11.49Zm4.42 0a7.07 7.07 0 1 1 7.07 7.08 7.06 7.06 0 0 1-7.07-7.08Z"
              className="header-svg__primary"
            />
            <path
              d="M93.78 303.59v43.74a5.75 5.75 0 0 1-5.78 5.75H55.35a5.75 5.75 0 0 1-5.76-5.75v-43.74Z"
              className="header-svg__primary"
            />
          </g>
          <path
            d="M338 286.26s-2.08 45.42-11.47 51.9-111.63-44.33-111.63-44.33 8.35 69.21-4.17 66c-.11 0 .19 2.27-.85 2.47-7.21 1.35-34.64 5.1-34.64 5.1s-7.3-55.15-11.47-96.24 47-19.47 47-19.47l72 29.2H312Z"
            className="header-svg__hair"
          />
          <path
            d="M338 286.26s-2.08 45.42-11.47 51.9-111.63-44.33-111.63-44.33 8.35 69.21-4.17 66c-.11 0 .19 2.27-.85 2.47-7.21 1.35-34.64 5.1-34.64 5.1s-7.3-55.15-11.47-96.24 47-19.47 47-19.47l72 29.2H312Z"
            className="header-svg__shadow"
          />
          <path
            d="M292.12 195.42s-34.44 50.82-37.57 56.23-98.09 76.78-98.09 76.78-63.65 25.95-74.09 13S148.11 310 148.11 310l82.44-71.37L265.91 186Z"
            className="header-svg__skin"
          />
          <path
            d="M292.12 195.42s-34.44 50.82-37.57 56.23-98.09 76.78-98.09 76.78-63.65 25.95-74.09 13S148.11 310 148.11 310l82.44-71.37L265.91 186Z"
            className="header-svg__shadow"
          />
          <path
            d="M321.34 186.77s-35.49 30.28-43.83 28.12S263.94 190 263.94 190l23-46.49Z"
            className="header-svg__t-shirt"
          />
          <path
            d="M321.34 186.77s-35.49 30.28-43.83 28.12S263.94 190 263.94 190l23-46.49Z"
            className="header-svg__shadow"
          />
          <path
            d="M7.42 255.8a1.76 1.76 0 0 1 1-.41 1.66 1.66 0 0 1 1.07.33 1.76 1.76 0 0 1 .66.92l28.24 89.8a1.33 1.33 0 0 0 0 .19v.19a1.23 1.23 0 0 1 0 .19 1.36 1.36 0 0 1 0 .2L34.25 386a1.84 1.84 0 0 1-.52 1.08 1.72 1.72 0 0 1-1 .51 1.69 1.69 0 0 1-1.13-.29 1.79 1.79 0 0 1-.7-1L.08 286.75v-.25a1.07 1.07 0 0 1 0-.25A1.93 1.93 0 0 1 0 286a1.5 1.5 0 0 1 0-.24l6.78-29a1.85 1.85 0 0 1 .64-.96Z"
            className="header-svg__hair"
          />
          <path
            d="m9.32 259.22 27.13 87.59-6.25 28.12L3.06 284.1l6.26-24.88Z"
            fill="#f2f2f2"
          />
          <path
            d="M146.1 387.91c-.54-13.59-3.21-43.26-3.21-43.26l-106.44 3.92-4.17 35s.9 2.17 1.88 4.33c.15.38.32.75.49 1.12s.36.74.55 1.1.39.72.6 1.07.43.69.65 1c1 1.09 108.53 5.41 109.58 2.16a35 35 0 0 0 .07-6.44Z"
            className="header-svg__hair"
          />
          <path
            d="M50 353.31h44.9v30.27h-47l2.1-30.27Z"
            className="header-svg__shadow"
          />
          <path
            d="M110.54 363h27.13v13h-26.08l-1.32-13 .27.06Z"
            className="header-svg__shadow"
          />
          <path
            d="M146.1 387.91H34.16c.15.38.32.75.49 1.12s.36.74.55 1.1.39.72.6 1.07.43.69.65 1c1 1.09 108.53 5.41 109.58 2.16a35 35 0 0 0 .07-6.45Z"
            className="header-svg__shadow"
          />
          <path
            d="M238.58 114.71a49.4 49.4 0 0 1-14.29-35c0-26.92 21-48.66 47-48.66S318.2 52.8 318.2 79.72s-21 48.66-46.95 48.66a46 46 0 0 1-32.67-13.67Z"
            className="header-svg__skin"
          />
          <path
            d="M307.77 84c-3.13 16.23 38.09 36.23 38.09 36.23L340.12 136s-43.83 45.42-47 30.28S274.38 123 274.38 123s36.52-55.18 33.39-39Z"
            className="header-svg__skin"
          />
          <path
            d="M316.12 217.05s-40.7 40-62.62 63.8S128.28 362 128.28 362s-48 22.71-64.7 10.82S121 344.65 121 344.65l102.27-78.94L266 207.32Z"
            className="header-svg__skin"
          />
          <path
            d="M416.29 346.81s-1 15.14-21.91 45.42c-17.91 26-113.45-15.73-140.18-28.08-4.41-2-9.82-.8-15.08.92-10.26 3.38-29.64 3.89-54.49-22.58-18.78-20-10.43-33.52 2.61-42a57 57 0 0 1 48.93-6.12l74.73 24.33 12.52-20.55c12.58-3.24 92.87 48.66 92.87 48.66Z"
            className="header-svg__hair"
          />
          <path
            d="m229.51 365.2 35.49-5.41s11.47 2.16 11.47 20.55S242 398.72 242 398.72s-29.22 15.14-68.87 4.33-6.27-33.53-6.27-33.53c19.86-16.22 62.65-4.32 62.65-4.32Z"
            className="header-svg__t-shirt"
          />
          <path
            d="M422.56 281.93c-2.09 20.55 4.17 78.94 4.17 78.94-12.52 31.36-77.22-19.46-77.22-35.69s-8.35-4.32-29.22-21.62-16.69-84.35-16.69-84.35-15.66-16.21-19.83-30.27 15.65-34.61 15.65-34.61 14.58-15.14 18.78-24.87c3.22-7.51 18.24-12.45 24.94-14.3a10.71 10.71 0 0 1 1.59-.34 12.75 12.75 0 0 1 1.63-.11 12.36 12.36 0 0 1 1.62.1 12.77 12.77 0 0 1 1.61.33c72.01 20.2 75.02 146.55 72.97 166.79Z"
            className="header-svg__t-shirt"
          />
          <path
            d="M359.94 187.85c-8.35 3.25-40.69 41.09-49 42.18s-47-18.39-47-18.39c-11.47-20.54 52.18-69.21 52.18-69.21 56.35-16.22 52.18 42.18 43.82 45.42Z"
            className="header-svg__t-shirt"
          />
          <path
            d="M225.42 94c.43.84.85 1.68 1.27 2.53q1.29 2.58 2.5 5.12l.42.72.51.89c1.32 2.27 2.64 4.08 2.64 4.08a9.07 9.07 0 0 0 2.93 2.78 2.19 2.19 0 0 0 .35.13 3.2 3.2 0 0 0 2.37-.53c1.21-.77.87-3.67.23-6.37-.14-.57-.12-.62-1.59-5.2a29.61 29.61 0 0 0-1.81-4.26l32.66-13.22 1.15-3.81-36.11 12.28s-.1-.25-.26-.29a.32.32 0 0 0-.22 0c-1.16.42-7.39 2.75-7.14 4.8a.93.93 0 0 0 .1.35Zm6.63 8.17c-.24-.54-2.93-6.11-3.85-8v-.07a.59.59 0 0 1 .26-.8l2-1a.55.55 0 0 1 .77.27v.09l3.72 8c.06.12.17.36.3.65 1.17 2.67 2.5 5.68 1.48 6.79l-.09.09h-.12c-1 .06-1.81-1.23-2.73-2.78-.99-1.81-1.5-2.68-1.74-3.22Z"
            className="header-svg__hair"
          />
        </g>
        <path
          d="M368.15 260.08 30.2 374.93 3.07 284.09l6.26-24.87L242.54 52.25l125.61 207.83z"
          className="header-svg__light"
          ref={lightRef}
        />
        <path
          d="M245.61 65c2.45 1.63 2.43 9.49 3.72 12.49C251 81.4 254 85 258 86.29c3.42 1.14 7.52.66 10.18 3.15 3.5 3.29 3.06 10.51 7.6 11.84 2.65.77 5.41-1.31 6.56-3.88s1.16-5.52 1.33-8.35a9.21 9.21 0 0 1 .06-1.29c0-.42.12-.85.21-1.26s.23-.83.37-1.23a12.34 12.34 0 0 1 .51-1.18c2.23-3.77 7.9-3.55 11.37-1s5.53 6.68 8.14 10.19c5.83 7.84 14.58 12.75 23.42 16.49-5.09-8.88-2.4-20.37 2.12-29.57.26-.48.51-1 .75-1.45s.47-1 .69-1.48.43-1 .62-1.52.39-1 .58-1.53.27-1.14.38-1.71.21-1.15.28-1.73.13-1.17.16-1.75.05-1.17 0-1.75a55.17 55.17 0 0 0-.3-6.8 58.38 58.38 0 0 0-1.14-6.71 56.48 56.48 0 0 0-1.95-6.5 54.25 54.25 0 0 0-2.73-6.2c-2.91-5.51-6.78-10.4-10.65-15.24-5.18-6.46-10.83-13.23-18.59-15.66C294.26 9 290.3 9 286.4 8.9l-24.11-.35c-4.13-.06-8.33-.12-12.32 1-9.58 2.61-16.46 11.31-21.11 20.37a36.77 36.77 0 0 1-4.09 6.91c-2.39 2.85-5.76 4.7-8.07 7.62-3.63 4.6-4 11-3.92 16.95a13 13 0 0 0 1 5.73c1.64 3.2 5.6 4.46 9.07 4s6.65-2.18 9.85-3.66c2.86-1.31 9.84-4.55 12.91-2.47Z"
          className="header-svg__hair"
        />
      </svg>

      <svg viewBox="0 0 415.91 415.91" className="header-svg__box">
        <path
          d="M52.11 0v415.91H24.7A24.7 24.7 0 0 1 0 391.21V24.7A24.7 24.7 0 0 1 24.7 0Z"
          className="header-svg__primary"
        />
        <path
          d="M21.45 0h369.76a24.7 24.7 0 0 1 24.7 24.7v366.51a24.7 24.7 0 0 1-24.7 24.7H21.45V0Z"
          className="header-svg__background"
        />
        <path
          d="M311.63 158.23q-5.14-1.77-10.37-3.27.87-3.53 1.6-7.08c7.85-38.11 2.72-68.81-14.81-78.92-16.81-9.69-44.29.42-72.06 24.57q-4.11 3.59-8 7.37c-1.76-1.68-3.54-3.32-5.34-4.94-29.09-25.83-58.24-36.71-75.77-26.58-16.79 9.72-21.77 38.59-14.7 74.71q1 5.35 2.38 10.67a211.88 211.88 0 0 0-11.92 3.75c-34.11 11.87-55.9 30.53-55.9 49.87 0 20 23.39 40 58.92 52.13 2.88 1 5.79 1.89 8.71 2.73q-1.42 5.7-2.53 11.5c-6.74 35.49-1.47 63.67 15.27 73.33 17.3 10 46.34-.28 74.6-25 2.24-1.95 4.48-4 6.74-6.19q4.24 4.08 8.71 7.94c27.38 23.56 54.44 33.08 71.16 23.39 17.28-10 22.9-40.28 15.61-77.11-.56-2.81-1.2-5.68-1.94-8.61 2-.6 4-1.22 6-1.87 36.93-12.24 61-32 61-52.25 0-19.41-22.49-38.17-57.29-50.15Z"
          className="header-svg__primary"
        />
        <path
          d="M304.14 247.57c-1.76.58-3.57 1.14-5.41 1.69a323.69 323.69 0 0 0-16.32-40.82 322 322 0 0 0 15.68-40.22q4.95 1.44 9.58 3c29.82 10.26 48 25.44 48 37.14 0 12.46-19.67 28.64-51.53 39.21Zm-13.23 26.22c3.22 16.28 3.68 31 1.55 42.51-1.91 10.34-5.77 17.24-10.54 20-10.16 5.88-31.87-1.76-55.29-21.91-2.68-2.31-5.39-4.78-8.1-7.39a324.56 324.56 0 0 0 27-34.29 321.28 321.28 0 0 0 43.64-6.71c.66 2.65 1.24 5.25 1.75 7.78ZM157.09 335.3c-9.93 3.5-17.83 3.6-22.6.85-10.16-5.87-14.39-28.52-8.62-58.85q1-5.37 2.34-10.69a326.3 326.3 0 0 0 43.42 6.29 334.52 334.52 0 0 0 27.66 34.16q-3 2.91-6.13 5.66c-12.5 10.93-25 18.66-36.07 22.58Zm-46.48-87.81c-15.71-5.37-28.68-12.35-37.58-20-8-6.85-12-13.64-12-19.15 0-11.74 17.49-26.7 46.66-36.87q5.49-1.92 11.09-3.49a330.87 330.87 0 0 0 15.7 40.69A334.06 334.06 0 0 0 118.57 250q-4.02-1.17-7.96-2.51Zm15.58-106c-6-30.94-2-54.29 8.08-60.14 10.78-6.22 34.62 2.66 59.74 25 1.61 1.42 3.22 2.92 4.83 4.45a331.26 331.26 0 0 0-27.44 34 335.53 335.53 0 0 0-43 6.69q-1.25-4.94-2.22-9.93Zm139 34.32q-4.71-8.16-9.79-16.11c10.28 1.3 20.13 3 29.38 5.13a291.49 291.49 0 0 1-10.32 27.75q-4.45-8.47-9.27-16.77Zm-56.69-55.2a296.42 296.42 0 0 1 19 22.88q-19-.88-38.08 0c6.25-8.25 12.67-15.92 19.12-22.87Zm-57 55.29q-4.75 8.24-9.1 16.67c-4-9.51-7.44-18.85-10.24-27.88 9.2-2.08 19-3.74 29.21-5q-5.15 8-9.88 16.23Zm10.16 82.26a294.79 294.79 0 0 1-29.66-4.83c2.85-9.18 6.35-18.73 10.45-28.44q4.36 8.45 9.13 16.67 4.84 8.4 10.09 16.55Zm47.25 39.05A297.83 297.83 0 0 1 189.5 274q9.25.38 18.85.37 9.85 0 19.45-.44a291.18 291.18 0 0 1-18.93 23.27Zm65.69-72.76a293 293 0 0 1 10.84 28.33 288.24 288.24 0 0 1-30.07 5.13q5.11-8.1 9.9-16.4t9.3-17.11Zm-21.26 10.19q-7.34 12.66-15.48 24.89c-9.56.68-19.44 1-29.51 1s-19.78-.31-29.17-.92q-8.34-12.18-15.76-25t-13.74-26q6.36-13.23 13.7-26Q170.72 170 179 157.84c9.59-.72 19.41-1.1 29.34-1.1s19.82.38 29.39 1.11q8.21 12.1 15.56 24.78t13.88 25.86q-6.45 13.27-13.84 26.08Zm28.4-153.7c10.79 6.22 15 31.31 8.2 64.22-.44 2.14-.93 4.27-1.45 6.4a329.74 329.74 0 0 0-43.08-6.81 324.5 324.5 0 0 0-27.23-34q3.63-3.48 7.41-6.79c23.78-20.7 46-28.87 56.15-23Z"
          className="header-svg__background"
        />
        <path
          d="M207.82 179.6a28.78 28.78 0 1 1-28.77 28.78 28.78 28.78 0 0 1 28.77-28.78"
          className="header-svg__primary"
        />
      </svg>
    </div>
  );
};

export default HeaderImage;
